/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetForm_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetForm_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "QuestionPicker_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetForm/__generated__/WidgetForm_surveys.graphql.js